module.exports = __webpack_public_path__ + "img/42.225647ba.jpg";